var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('picture',[_vm._l((_vm.srcsets),function(ref){
var type = ref.type;
var srcset = ref.srcset;
return _c('source',{key:type,attrs:{"srcset":srcset,"sizes":_vm.sizes,"type":("image/" + type),"media":_vm.media}})}),_c('img',{staticClass:"responsive-image",style:(_vm.css),attrs:{"src":"data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=","alt":_vm.alt}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }